import styled from "@emotion/styled";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Layout from "components/structure/Layout";
import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Grid, IconButton, InputAdornment } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthData } from "auth/AuthWarpper";
import DataTable from "utils/DataTable/DataTable";
import NoData from "assets/noData.svg";
import PaginationImport from "../Common/PaginationImport";
import ViewButton from "utils/ViewButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ImportHierarchyService from "services/ImportHierarchyService";
import ClearIcon from "@mui/icons-material/Clear";
import { SnackbarContext } from "context/snackBarContext";
import ImportService from "services/ImportService";
import { convertToLocalTime } from "utils/CommonFunction";
import CustomPagination from "../Common/CustomPagination";
const columns = [
  
  {
    field: "grower-number",
    headerName: "Grower No",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "farmer-name",
    headerName: "Farmer Name",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "state",
    headerName: "State Province",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "farmer-lta",
    headerName: "Farmer LTA",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
    headerAlign: "left",
    align: "left",
    renderCell: (params) => (
      <span style={{ color: params.value === "Fail" ? "red" : "green" }}>
        {params.value}
      </span>
    ),
  },
  {
    field: "operation",
    headerName: "Operation",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "error-description",
    headerName: "Error Description",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "actions",
    type: "actions",
    headerName: "View Details",
    width: 250,
    headerAlign: "left",
    align: "left",
    getActions: (params) => {
      const state = {
        id: params.id,
        farmerLogId: params.row['farmer-log-id'],
        growerNumber: params.row['grower-number'],
        farmerName: params.row['farmer-name'],
        state: params.row.state,
        farmerLta: params.row['farmer-lta'],
        operation: params.row.operation,
        errorDescription: params.row['error-description'],
        status: params.row.status,
      };
      const url = `/viewFarmerDetails/${params.id}`;
      return [<ViewButton state={state} url={url} />];
    },
  },
];

const ViewLog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = AuthData();
  const params = useParams();
  const { id } = params;
  const dataPrev = location.state;
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(5);
  const [data, setData] = useState([]);
  const [value, setValue] = useState("");
  const {
    severity,
    message,
    openAlert,
    setOpenAlert,
    setSeverity,
    setMessage,
  } = React.useContext(SnackbarContext);
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const paginate = (pageNumber, itemsPerPage) => {
    callHierarchyAPI(pageNumber - 1, itemsPerPage);
  };

  useEffect(() => {
    callHierarchyAPI(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage, value]);

  const callHierarchyAPI = (pNumber, size) => {
    setLoading(true);
    const query = {
      id: id,
      pageNumber: pNumber,
      size: size,
      status: value ? value == "All" ? "" : value : undefined,
    };

    ImportHierarchyService.FetchAllFarmerViewLog(query)
      .then((res) => {
        setCurrentPage(pNumber);
        setItemsPerPage(size);
        let rows = res?.data?.response?.importFarmerLogs;
        let newRows = rows.map(row => ({
          ...row,
          farmerLogId: row['farmer-log-id']
        }));
        setData(newRows);
        setTotalItems(res?.data?.response?.totalItems);
      })
      .catch((error) => {
        setData([]);
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        console.error("API call failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleExportAll = async () => {
    try {
      const response = await ImportService.ExportAll({ ilHeaderId: id }, {
        responseType: 'text' // Expecting the response as plain text (CSV content)
      });

      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }

      const BOM = '\uFEFF'; // UTF-8 BOM
      const fileContent = BOM + response.data;
      // Create a Blob from the text content
      
      const blob = new Blob([fileContent], { type: 'text/csv;charset=utf-8;' }); // Ensure MIME type is 'text/csv'
      // Create a URL for the Blob and trigger a download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.csv'; // Set the file name for download
      document.body.appendChild(a); // Append the anchor to the document
      a.click(); // Trigger the download
      document.body.removeChild(a); // Remove the anchor from the document
      window.URL.revokeObjectURL(url); // Clean up the object URL
    } catch (error) {
      console.error('Error downloading file:', error);
      // Handle the error (e.g., show a message to the user)
    }
  };

  // Example for Base64 data
  const decodeBase64 = (base64String) => {
    const binaryString = window.atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: 'application/octet-stream' });
  };

  const handleExportAllwithbase64 = async () => {
    try {
      const response = await ImportService.ExportAll({ ilHeaderId: id }, {
        responseType: 'text'
      });

      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }

      const fileContent = response.data;

      // Decode Base64 data if necessary
      const blob = decodeBase64(fileContent);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setSeverity("error");
      setLoading(false);
    }
  };

  return (
    <Layout title="Agri360 ESG Portal">
      <div style={{ paddingBottom: "4rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Heading>Import Farmer</Heading>
          <Button
            sx={{
              borderRadius: 100,
              minWidth: 95,
              minHeight: 44,
              background: "#102A62",
            }}
            variant="contained"
            startIcon={<KeyboardBackspaceIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>
        <PaperContainer>
          <form autoComplete="off">
            <Grid container spacing={2}>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", sx: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  File Name
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev?.fileName === null ? "null" : dataPrev?.fileName
                    }
                    name="profileCode"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  Uploaded By User
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev.uploadedBy === null
                        ? "null"
                        : dataPrev.uploadedBy
                    }
                    name="profileCode"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "none" },
                  alignItems: "center",
                  flexDirection: "end",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  Upload Status
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev.uploadStatus === null
                        ? "null"
                        : dataPrev.uploadStatus
                    }
                    name="profileCode"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", sx: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  Comments
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="my-input"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev.comments === null ? "null" : dataPrev.comments
                    }
                    name="profileName"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", sx: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  Timestamp
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="my-input"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev.timestamp === null ? "null" : dataPrev.timestamp
                    }
                    name="profileName"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "flex" },
                  alignItems: "center",
                  flexDirection: "end",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  Success/Fail
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="my-input"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={dataPrev.success + "/" + dataPrev.fail}
                    name="profileName"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
        </PaperContainer>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 1,
          }}
        >
          <Box>
            <FormControl
              sx={{ m: 1, minWidth: { xs: 150, md: 300 }, minHeight: 50 }}
            >
              <TextField
                select
                value={value}
                onChange={handleChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                label={value ? "" : "Status"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div
                        edge="end"
                        onClick={() => setValue("")}
                        sx={{ visibility: value !== "" ? "visible" : "hidden" }}
                      >
                        <ClearIcon sx={{ mt: 0.5, mr: 2, cursor: "pointer", visibility: value !== "" ? "visible" : "hidden" }} />
                      </div>
                    </InputAdornment>
                  ),
                }}

              >
                <MenuItem value="All">
                  All
                </MenuItem>
                <MenuItem value="Success">Success</MenuItem>
                <MenuItem value="Fail">Fail</MenuItem>
              </TextField>
            </FormControl>
          </Box>
          <Box>
            <Button
              sx={{
                borderRadius: 2,
                minWidth: 156,
                minHeight: 44,
                background: "#EF7D00",
                marginTop: { xs: 1 },
                marginLeft: { xs: 1 },
                "&:hover": {
                  background: "#EF7D00",
                },
              }}
              startIcon={loading && <CircularProgress size={20} />}
              variant="contained"
              onClick={() => handleExportAll()}
              disabled={loading}
            >
              Export All
            </Button>
          </Box>
        </Box>
        <Box>
          {data.length !== 0 ? (
            <>
              <DataTable
                getRowId={(row) => row?.farmerLogId}
                data={data}
                rows={data}
                columns={columns}
                hideFooter={true}
              />


            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={NoData} style={{ height: "100px" }} alt="No Data" />
              <p>No Data Available</p>
            </Box>
          )}
        </Box>
      </div>
      {data.length !== 0 ?
      <Box>
        <div style={{ position: "absolute", width: "96%", bottom: "70px" }}>
          <CustomPagination
            itemsPerPage={itemsPerPage}
            setItemsPerPage={(v) => setItemsPerPage(v)}
            totalItems={totalItems}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </Box>:""}
    </Layout>
  );
};

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const PaperContainer = styled(Paper)`
  padding: 2rem 1rem;
`;

export default ViewLog;
